"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTranslateOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M18 8V6h-7V3H9v3H2v2h10.74a16.4 16.4 0 01-3.2 5.93A22.7 22.7 0 017.18 10H5a23.36 23.36 0 003.15 5.43 19.44 19.44 0 01-5.56 3.66l.82 1.82a21.58 21.58 0 006.05-4 14.26 14.26 0 006.35 4l.55-1.91a12.37 12.37 0 01-5.51-3.55 18.49 18.49 0 004-7.49zM20.13 24h6.74l1.07 3h2.12L24.7 12h-2.4l-5.36 15h2.12zm3.37-9.43L26.15 22h-5.3z" })));
}
exports.default = SvgTranslateOutline;
//# sourceMappingURL=TranslateOutline.js.map